import type { BuildPhotoEntry } from './buildApi';

/** Keep the per-mailbox mapping, but send a shared persona's bytes only once. */
export function compactBuildPhotos(photos: { enabled?: boolean; images?: Record<string, BuildPhotoEntry> }) {
  const assets: Record<string, BuildPhotoEntry> = {};
  const images: Record<string, BuildPhotoEntry | { ref: string }> = {};
  const seen = new Map<string, string>();
  for (const [email, entry] of Object.entries(photos.images ?? {})) {
    if (!('b64' in entry)) {
      images[email] = entry;
      continue;
    }
    const key = JSON.stringify([entry.b64, entry.mime ?? null]);
    let ref = seen.get(key);
    if (ref === undefined) {
      ref = `photo-${seen.size + 1}`;
      seen.set(key, ref);
      assets[ref] = entry;
    }
    images[email] = { ref };
  }
  return { enabled: photos.enabled, images, ...(seen.size ? { assets } : {}) };
}
